<template>
  <div class="page-upload">
    <div class="upload">订单上传中…</div>
    <div class="time">30s</div>
    <div class="detail">
      <div class="cell">
        <div class="title">充电站地址</div>
        <div class="value">北京市朝阳区高碑店西店记忆充电站</div>
      </div>
      <div class="cell">
        <div class="title">充电站编号</div>
        <div class="value">{{gunNumber}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGunOrderStatus } from "../../../common/api";

export default {
  name: "upload",
  components: {},
  data() {
    return {
      pauseEndTime: new Date(),
      leftTime: { s: null, ms: null },
      accountPkId: null,
      gunNumber: null,
      serialNumber: null,
      orderNo: null,
      timer: null
    };
  },
  mounted() {
    this.pauseEndTime.setMinutes(
      this.pauseEndTime.getMinutes() + 3,
      this.pauseEndTime.getSeconds(),
      0
    );
    this.countDown();

    this.accountPkId = this.$route.query.accountPkId;
    this.gunNumber = this.$route.query.gunNumber;
    this.serialNumber = this.$route.query.serialNumber;
    this.orderNo = this.$route.query.orderNo;
    this.startCharging();
    this.pollUpdate();
  },
  methods: {
    getGunOrderStatus() {
      getGunOrderStatus({
        orderNo: this.orderNo
        // gunNumber: this.gunNumber
      })
        .then(data => {
          console.log(data);
          if (data.status === this.$config.ajaxStatus) {
            if (data.data[0].orderStatus === 2) {
              //充电完成，跳转到充电结束界面等待拔枪
              this.$router.replace({
                name: "charge/finish",
                query: {
                  accountPkId: this.accountPkId,
                  gunNumber: this.gunNumber,
                  serialNumber: this.serialNumber,
                  orderNo: this.orderNo,
                  replace: true
                }
              });
            } else if (
              data.data[0].orderStatus === 5 &&
              data.data[0].orderStatus === 9
            ) {
              //充电完成，跳转到充电结束界面等待拔枪
              this.$router.replace({
                name: "order-not-pay",
                query: {
                  accountPkId: this.accountPkId,
                  gunNumber: this.gunNumber,
                  serialNumber: this.serialNumber,
                  orderNo: this.orderNo,
                  replace: true
                }
              });
            } else {
              this.$common.checkOrderIsAbnormal(
                this.$router,
                data.data[0].orderStatus
              );
            }
          } else {
            throw new Error(data.msg);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    pollUpdate() {
      this.timer = setInterval(() => {
        this.refresh();
      }, this.$config.pullTimeDistance);
    },
    refresh() {
      this.startCharging();
    },

    countDown() {
      var nowTime = new Date();
      var leftTime = parseInt(
        (this.pauseEndTime.getTime() - nowTime.getTime()) / 1000
      );
      var ms = parseInt(
        (this.pauseEndTime.getTime() - nowTime.getTime()) % 1000
      );
      // var d = parseInt(leftTime / (24 * 60 * 60));
      // var h = parseInt(leftTime / (60 * 60) % 24);
      var m = parseInt((leftTime / 60) % 60);
      var s = parseInt(leftTime % 60);
      // d = this.addZero(d);
      // h = this.addZero(h);
      // m = this.addZero(m);
      // s = this.addZero(s);
      console.log(ms);
      console.log(ms / 100);
      console.log((ms / 100).toFixed(0));
      this.leftTime.s = `${m * 60 + s}.`;
      this.leftTime.ms = `${parseInt(ms / 100)}`;
      if (leftTime <= 0) {
        return;
      }
      setTimeout(this.countDown, 100);
    },
    addZero(num) {
      return num < 10 ? "0" + num : num;
    }
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.timer);
    next();
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/less/old/var.less";

.page-upload {
  width: 100%;
  .upload {
    font-size: 0.36rem;
    color: #333333;
    font-weight: 500;
    margin-top: 0.72rem;
    text-align: center;
  }
  .time {
    font-size: 0.36rem;
    color: #14cc80;
    margin-top: 0.1rem;
    text-align: center;
  }
  .detail {
    box-sizing: border-box;
    margin: 0.3rem 0.2rem 0.2rem 0.2rem;
    background: #f8f4f5;
    border-radius: 0.1rem;
    .cell {
      display: flex;
      align-items: center;
      padding: 0.08rem;
      line-height: 0.6rem;
      .title {
        font-size: 0.28rem;
        color: #999999;
        margin-right: 0.2rem;
      }
      .value {
        font-size: 0.28rem;
        color: #666666;
        flex: 1;
        text-align: end;
      }
    }
  }
}
</style>
